import { render, staticRenderFns } from "./FrzCreationTable.vue?vue&type=template&id=610ae93c"
import script from "./FrzCreationTable.vue?vue&type=script&lang=js"
export * from "./FrzCreationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports